// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.timeTips {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n  text-align: center;\n  background: #2c2c2c;\n  color: #fff;\n  border-radius: 50%;\n  margin-left: 5px;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
